import { Dialog } from "primereact/dialog";
import { FC, useEffect, useState } from "react";
import { RootState, useAppSelector } from "../redux/AppStore";
import DriverLocationMapComponent from "./Map/LiveLocationComponent";
type DialogProps = {
  visibles: boolean;
  setVisibles: (show: boolean) => void;
}

const DriverLocationDialog: FC<DialogProps> = ({ visibles, setVisibles }) => {
  const trackingNumber = useAppSelector((state: RootState) => state.tracking.trackingNum);
  const totaldrops = useAppSelector((state: RootState) => state.tracking.total_drops);
  const [rcount, setrcount] = useState('');

  useEffect(() => {
    for (let d of totaldrops.total_drops) {
      if ((d.load_identity == trackingNumber || d.shipment_ticket == trackingNumber)) {
        setrcount(d.execution_order);
      }
    }
  }, [totaldrops])

  const countExecutionOrdersBeforeFive = () => {
    let uniqueExecutionOrders = new Set();
    let count = 0;
  
    for (const drop of totaldrops.total_drops) {
      if (drop.execution_order === rcount) {
        break;
      }
      uniqueExecutionOrders.add(drop.execution_order);
      count++;
    }
  
    return uniqueExecutionOrders.size;
  };
  const uniqueCount = countExecutionOrdersBeforeFive();

  return (

    <><style>{`
      
  .pac-container.pac-logo.hdpi {z-index: 999999 !important;
   }.map_Section{
    width: 100% !important;
}
canvas.mapboxgl-canvas {
    width: 100% !important;
    height: 100% !important;
}
.map_Section #mapbol {
    width: 100% !important;
    }`
  }
    </style><Dialog className="av_verify" header="Live Location" visible={visibles} onHide={() => { if (!visibles) return; setVisibles(false); }}
      style={{ width: '65vw', backgroundColor: 'White' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
        <div className="modal-header UpdateVerify_Head">
          <div className="header_container">
            <div className="h_left">
              {uniqueCount != 0 &&
              <h4><span className="remaining_job">{uniqueCount}</span> Jobs Ahead</h4>
}
            </div>
            
            <div className="h_right">
              <button type="button" className="btn-close UpdateVerify_close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setVisibles(false)}><i className="fa-solid fa-circle-xmark"></i></button>
            </div>
          </div>
        </div>
        <DriverLocationMapComponent />
      </Dialog></>
  )
}

export default DriverLocationDialog;